
import React from 'react';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  // Simplified pagination: display all page numbers if few, else some ellipsis logic could be added.
  // For this example, let's show up to 5 page buttons, and current page +-2
  const maxPagesToShow = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  if (endPage - startPage + 1 < maxPagesToShow && totalPages >= maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
  }
  
  const visiblePageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    visiblePageNumbers.push(i);
  }


  return (
    <nav className="flex justify-end items-center mt-6 pt-4 border-t border-slate-200" aria-label="Table navigation">
      <ul className="inline-flex items-center -space-x-px">
        <li>
          <button
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
            className={`px-3 py-2 ml-0 leading-tight rounded-l-lg 
                        ${currentPage === 1 ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-white text-slate-500 hover:bg-indigo-50 hover:text-indigo-600 border border-slate-300'}`}
          >
            Previous
          </button>
        </li>

        {startPage > 1 && (
             <li>
                <button className="px-3 py-2 leading-tight bg-white text-slate-500 border border-slate-300">...</button>
            </li>
        )}

        {visiblePageNumbers.map(number => (
          <li key={number}>
            <button
              onClick={() => onPageChange(number)}
              className={`px-3 py-2 leading-tight border border-slate-300
                          ${currentPage === number ? 'bg-indigo-600 text-white border-indigo-600 z-10' : 'bg-white text-slate-500 hover:bg-indigo-50 hover:text-indigo-600'}`}
            >
              {number}
            </button>
          </li>
        ))}
        
        {endPage < totalPages && (
             <li>
                <button className="px-3 py-2 leading-tight bg-white text-slate-500 border border-slate-300">...</button>
            </li>
        )}


        <li>
          <button
            onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
            className={`px-3 py-2 leading-tight rounded-r-lg 
                        ${currentPage === totalPages ? 'bg-slate-100 text-slate-400 cursor-not-allowed' : 'bg-white text-slate-500 hover:bg-indigo-50 hover:text-indigo-600 border border-slate-300'}`}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
